import getDoubleDiscData from './getDoubleDiscData';
import getNumPattern from './getNumPattern';
import getLongQueueContinue from './getLongQueueContinue';
import getRoads from './getRoads';
import getHotCold from './getHotCold';
import getBallRoads from './getBallRoads';

export default {
  getDoubleDiscData,
  getNumPattern,
  getLongQueueContinue,
  getRoads,
  getHotCold,
  getBallRoads
};



// WEBPACK FOOTER //
// ./src/helpers/statistic/index.js